<div class="ut-tabs">
  <ul class="nav nav-tabs" role="tablist">
    @for (tab of tabs; track tab) {
      <li
        class="nav-item"
        [class.active]="tab.active"
        role="presentation">
        <a
          class="nav-link"
          [class.active]="tab.active"
          (click)="onTabClick(tab.tabId)"
          (keydown.enter)="onTabClick(tab.tabId)"
          (keydown.space)="onTabClick(tab.tabId); $event.preventDefault()"
          [attr.aria-selected]="tab.active"
          tabindex="0"
          role="tab"
          [attr.aria-controls]="'tab-panel-' + tab.tabId">
          {{ tab.label }}
        </a>
      </li>
    }
  </ul>

  <div class="ut-tabs-content tab-content">
    <ng-content></ng-content>
  </div>
</div>
